import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/live';
import {TMemberSubscription} from '../memberTicket.type';
import * as css from './MemberTicketActions.css';

/* Button is a library component — its inner DOM is not ours to reach into with a selector */
const fullWidth = {justifyContent: 'center', width: '100%'} as const;

interface MemberTicketActionsProps {
    subscription: TMemberSubscription;
    onMyTickets: () => void;
    onRedeem: () => void;
}

/* On an inactive subscription the redeem button is disabled rather than hidden,
   so the member still sees the action exists but is not available right now. */
function MemberTicketActions({subscription, onMyTickets, onRedeem}: MemberTicketActionsProps) {
    const {t} = useTranslation('eTicket');
    // Used credits, not the redeemed list — the credits come with the card itself, so the number
    // is there on entering the slide and does not wait for the tickets page to load
    const ticketsCount = subscription.usedCredits;

    return (
        <css.actions data-cy="member-ticket-actions">
            <Button
                variant="neutral"
                size="primary"
                inverse
                customStyle={fullWidth}
                onClick={onMyTickets}
                data-cy="member-my-tickets-button">
                {ticketsCount ? t('myTickets', {count: ticketsCount}) : t('myTicketsTitle')}
            </Button>
            <Button
                variant="brand"
                size="primary"
                customStyle={fullWidth}
                disabled={subscription.status !== 'active'}
                onClick={onRedeem}
                data-cy="member-redeem-button">
                {t('redeemTickets')}
            </Button>
        </css.actions>
    );
}

export default MemberTicketActions;
